import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { Store } from '@softline/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT } from './authentication.shared';
import { AuthenticationContextStore } from './authentication-context.store';
import { JwtHelper } from './jwt-authentication/utilities/jwt-helper';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationContextService<
  T extends {
    userId: number;
    username: string;
    userFullName: string;
    personalid: number;
  },
> {
  private store = inject(Store);

  claims = toSignal(
    this.store
      .observe(
        SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
        AuthenticationContextStore.getters.data
      )
      .pipe(map((data) => data as T))
  );
  personalid = computed(() => this.claims()?.personalid); //lstfixId
  userId = computed(() => this.claims()?.userId);
  userName = computed(() => this.claims()?.username);
  userFullName = computed(() => this.claims()?.userFullName);

  set(data: string): void;
  set(data: T): void;
  set(data: T | string): void {
    this.store.commit(
      SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
      AuthenticationContextStore.mutations.set,
      typeof data === 'string' ? JwtHelper.getPayload(data) : data
    );
  }

  update(updateFn: (current: T | undefined) => T): void {
    this.set(updateFn(this.claims()));
  }

  patch(updateFn: (current: T | undefined) => Partial<T>): void {
    this.set({
      ...(this.claims() ?? {}),
      ...updateFn(this.claims()),
    } as T);
  }
}
